"use client";

import { Link } from "@tanstack/react-router";

export default function LoginBtn() {
  return (
    <Link
      to="/account/login"
      className="rounded-lg bg-sky-500 px-4 py-2 text-center text-sm font-medium text-white hover:bg-sky-800 focus:outline-none focus:ring-4 focus:ring-blue-300"
    >
        Login
    </Link>
  );
}
